import type { KeyValueCallback } from 'types/utils.type';
import type { TPeriod } from '@timeedit/types';
import GeneralInfo from './GeneralInfo';
import Intervals from './Intervals';

export interface TPeriodProps {
  data?: TPeriod;
  onChange: KeyValueCallback<TPeriod>;
}

const PeriodDetail = (props: TPeriodProps) => {
  const { data, onChange } = props;
  if (!data) return null;
  return (
    <div className="padding-rule">
      <GeneralInfo data={data} onChange={onChange} />
      <Intervals data={data} onChange={onChange} />
    </div>
  );
};

export default PeriodDetail;
